import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import { AgreementFormValues } from "@modules/agreements/validations/agreementSchema";
import React from "react";
import { agreementAppSchema } from "@modules/agreementApps/validations";
import { useCreateAgreementAppMutation } from "@modules/agreementApps/services/mutation/createAgreementApp";

export function useAgreementAppCreateForm() {
  const { mutateAsync, isPending } = useCreateAgreementAppMutation();

  const methods = useForm<AgreementFormValues>({
    resolver: zodResolver(agreementAppSchema()),
    defaultValues: {
      bundleIdentifier: "br.com.partiu",
      version: "1.0.0",
      versionCode : '1',
      iosPurchaseToken: 'vazio',
      androidPurchaseToken: 'vazio',
    },
    mode: "onBlur",
  });

  const {
    handleSubmit,
    watch,
    formState: { errors },
  } = methods;

  React.useEffect(() => {
    const slug = watch("slug");
    if(slug) {
      const formattedSlug = slug.toLowerCase().replace(/\s+/g, "-");
      methods.setValue("slug", formattedSlug, { shouldDirty: true });
      methods.setValue("bundleIdentifier", `br.com.partiu.${formattedSlug}`);
    }
  }, [watch("slug")]);

  return {
    methods,
    isPending,
    handleSubmit,
    mutateAsync,
  };
}
